export const executionStatusGroup = [
  {
    label: '全部',
    value: '',
    en: 'allCount',
    count: 0,
  },
  {
    label: '已发货',
    value: '1',
    en: 'deliveryCount',
    count: 0,
  },
  {
    label: '已取消',
    value: '2',
    en: 'cancelCount',
    count: 0,
  },
];
